import React, { useRef, useState } from 'react';
import { cancelarReserva, Cita } from '../../services/citasService';

export const bloqueoCancelacion = (cita: Cita): string => {
  if (cita.estado === 'Cancelada') return 'Esta reserva ya está cancelada.';
  if (Number(cita.monto_pagado || 0) > 0 || cita.estado_pago !== 'Pendiente')
    return 'No se puede cancelar una reserva con pagos, incluidos pagos parciales.';
  return '';
};

export default function CancelarReservaPanel({ cita, token, onIdentify, onClose, onSuccess }: {
  cita: Cita; token: string | null | undefined; onIdentify: () => void;
  onClose: () => void; onSuccess: (cita: Cita) => void;
}) {
  const [motivo, setMotivo] = useState('');
  const [error, setError] = useState('');
  const [guardando, setGuardando] = useState(false);
  const sending = useRef(false);
  const bloqueo = bloqueoCancelacion(cita);
  const confirmar = async (e: React.FormEvent) => {
    e.preventDefault();
    if (sending.current || bloqueo || !motivo.trim()) return;
    if (!token) { onIdentify(); return; }
    sending.current = true; setGuardando(true); setError('');
    try { onSuccess(await cancelarReserva(cita.id, motivo.trim(), token)); }
    catch (err: any) {
      const data = err?.response?.data;
      if (err?.response?.status === 404 && typeof data === 'string') {
        setError('El servidor no reconoce la ruta de cancelación. Actualiza el backend de comarca-preproduccion y reinícialo.');
        return;
      }
      setError(String(data?.detail || data?.motivo || err?.message || 'No se pudo cancelar la reserva. Intenta nuevamente.'));
    } finally { sending.current = false; setGuardando(false); }
  };
  return <form onSubmit={confirmar} aria-label="Confirmar cancelación" className="my-4 rounded-xl border border-red-200 bg-red-50 p-5">
    <h3 className="font-bold text-red-800">¿Cancelar esta reserva?</h3>
    <p className="my-2 text-sm text-slate-700">Se liberará el horario y se devolverán al inventario los productos de cafetería. El detalle se conservará como historial.</p>
    {bloqueo ? <p role="alert">{bloqueo}</p> : <>
      <label className="block text-sm font-semibold" htmlFor="motivo-cancelacion">Motivo de cancelación</label>
      <textarea autoFocus id="motivo-cancelacion" required maxLength={500} value={motivo} disabled={guardando} onChange={e => setMotivo(e.target.value)} className="mt-2 w-full rounded-lg border border-red-200 bg-white p-3" rows={2}/>
      {!token && <p className="my-2 text-sm">Identifica al operador con su PIN para confirmar.</p>}
    </>}
    {error && <p role="alert" className="my-2 text-red-700">{error}</p>}
    <div className="mt-3 flex flex-wrap gap-3">
      <button type="button" disabled={guardando} onClick={onClose} className="rounded-lg border bg-white px-4 py-2">Mantener reserva</button>
      <button type="submit" disabled={guardando || !!bloqueo || !motivo.trim()} className="rounded-lg bg-red-600 px-4 py-2 font-semibold text-white disabled:opacity-50">{guardando ? 'Cancelando…' : token ? 'Confirmar cancelación' : 'Identificar operador'}</button>
    </div>
  </form>;
}
